module.exports = __webpack_public_path__ + "static/media/memorial_day_2024_banner.6eb3b5cd.jpg";